import { getClinicStructuredData } from "./clinic";

export function getSouthLakeStructuredData() {
  return getClinicStructuredData("southlake", [
    { name: "Locations", path: "/locations/" },
    { name: "Texas", path: "/locations/texas/" },
    { name: "Southlake", path: "/locations/texas/south-lake/" },
  ]);
}
